"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasVideo = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.function.name");

var _once2 = _interopRequireDefault(require("lodash/once"));

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

var _Helpers = require("../../../Helpers");

var _VideoControls = require("../../Sections/VideoControls");

var _react = _interopRequireWildcard(require("react"));

var _reactTracking = _interopRequireDefault(require("react-tracking"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _resizer = require("../../../../Utils/resizer");

var _dec, _dec2, _class, _class2, _class3, _temp;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    height: auto;\n    overflow: visible;\n    video {\n      height: auto;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

var CanvasVideo = (_dec = (0, _reactTracking.default)(), _dec2 = (0, _reactTracking.default)((0, _once2.default)(function (props) {
  return {
    action: "Click",
    label: "Display ad play video",
    entity_type: "display_ad",
    campaign_name: props.campaign.name,
    unit_layout: "canvas_standard"
  };
})), _dec(_class = (_class2 = (_temp = _class3 =
/*#__PURE__*/
function (_Component) {
  _inherits(CanvasVideo, _Component);

  function CanvasVideo(props) {
    var _this;

    _classCallCheck(this, CanvasVideo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CanvasVideo).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "video", void 0);

    _defineProperty(_assertThisInitialized(_this), "trackProgress", function () {
      var secondsComplete = Math.floor(_this.video.currentTime);
      var percentComplete = Math.floor(_this.video.currentTime / _this.video.duration * 100);
      var percentCompleteInterval = Math.floor(percentComplete / 25) * 25; // Track 25% duration intervals

      if (percentCompleteInterval > 0) {
        _this.trackDuration(percentCompleteInterval);
      } // Track 3 & 10 seconds


      if (secondsComplete === 3 || secondsComplete === 10) {
        _this.trackSeconds(secondsComplete);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "trackDuration", (0, _memoize2.default)(function (percentComplete) {
      _this.props.tracking.trackEvent({
        action: "Video duration",
        label: "Display ad video duration",
        percent_complete: percentComplete,
        campaign_name: _this.props.campaign.name,
        unit_layout: "canvas_standard"
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "trackSeconds", (0, _memoize2.default)(function (secondsComplete) {
      _this.props.tracking.trackEvent({
        action: "Video seconds",
        label: "Display ad video seconds",
        seconds_complete: secondsComplete,
        campaign_name: _this.props.campaign.name,
        unit_layout: "canvas_standard"
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "playVideo", function () {
      if (_this.video) {
        _this.video.play();

        _this.setState({
          isPlaying: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pauseVideo", function () {
      if (_this.video) {
        _this.video.pause();

        _this.setState({
          isPlaying: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVideo", function () {
      if (_this.state.isPlaying) {
        _this.pauseVideo();
      } else {
        _this.playVideo();
      }
    });

    _this.onPlayVideo = _this.onPlayVideo.bind(_assertThisInitialized(_this));
    _this.state = {
      isPlaying: false
    };
    return _this;
  }

  _createClass(CanvasVideo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onInit = this.props.onInit;

      if (onInit) {
        // Pass handlers back to CanvasContainer so that it can pause video
        // when Display is clicked.
        onInit({
          playVideo: this.playVideo,
          pauseVideo: this.pauseVideo,
          toggleVideo: this.toggleVideo
        });
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      this.video.removeEventListener("timeupdate", this.trackProgress);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.video.addEventListener("timeupdate", this.trackProgress);
    }
  }, {
    key: "onPlayVideo",
    value: function onPlayVideo() {
      this.toggleVideo();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isPlaying = this.state.isPlaying;
      var _this$props = this.props,
          coverUrl = _this$props.coverUrl,
          src = _this$props.src;
      var resized_cover = coverUrl && (0, _resizer.resize)(coverUrl, {
        width: 760,
        isDisplayAd: true
      });
      return _react.default.createElement(VideoContainer, {
        onClick: this.onPlayVideo
      }, !isPlaying && _react.default.createElement(Cover, {
        coverUrl: resized_cover,
        className: "CanvasVideo__cover"
      }, _react.default.createElement(_VideoControls.VideoControls, null)), _react.default.createElement("video", {
        playsInline: true,
        src: src,
        className: "CanvasVideo__video",
        controls: false,
        ref: function ref(video) {
          return _this2.video = video;
        }
      }));
    }
  }]);

  return CanvasVideo;
}(_react.Component), _defineProperty(_class3, "defaultProps", {
  coverUrl: ""
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, "onPlayVideo", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "onPlayVideo"), _class2.prototype)), _class2)) || _class);
exports.CanvasVideo = CanvasVideo;

var VideoContainer = _styledComponents.default.div.withConfig({
  displayName: "CanvasVideo__VideoContainer",
  componentId: "o24y14-0"
})(["width:65%;max-width:760px;height:100%;overflow:hidden;position:relative;video{width:100%;height:100%;object-fit:cover;}", ";"], _Helpers.pMedia.sm(_templateObject()));

var Cover = _styledComponents.default.div.attrs({}).withConfig({
  displayName: "CanvasVideo__Cover",
  componentId: "o24y14-1"
})(["background:url(", ") no-repeat center center;background-size:cover;position:absolute;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center;z-index:10;"], function (p) {
  return p.coverUrl || "";
});
//# sourceMappingURL=CanvasVideo.js.map